function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { getIsAdmin } from 'shared/account/reducer';
import ModalConfirm from 'shared/components/ModalConfirm';
import { T, useTranslate } from 'shared/helper/translate';
var noop = function noop() {};
var CancelFapiaoLink = function CancelFapiaoLink(_ref) {
  var cancelFapiao = _ref.cancelFapiao,
    fapiao = _ref.fapiao,
    _ref$onFapiaoCancelle = _ref.onFapiaoCancelled,
    onFapiaoCancelled = _ref$onFapiaoCancelle === void 0 ? noop : _ref$onFapiaoCancelle,
    paymentDate = _ref.paymentDate;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    fapiaoCancellationModalDisplayed = _useState2[0],
    setFapiaoCancellationModalDisplayed = _useState2[1];
  var handleCancelFapiao = function handleCancelFapiao() {
    return cancelFapiao(fapiao).then(function (_ref2) {
      var fapiao = _ref2.fapiao;
      return onFapiaoCancelled(fapiao);
    });
  };
  var today = new Date();
  var transactionDate = Date.parse(paymentDate);
  var oneYearAgo = today.setFullYear(today.getFullYear() - 1);
  var isAdmin = useSelector(getIsAdmin);
  var showFapiaoCancelLink = (fapiao === null || fapiao === void 0 ? void 0 : fapiao.completed) && (transactionDate > oneYearAgo || isAdmin);
  return showFapiaoCancelLink ? /*#__PURE__*/React.createElement(React.Fragment, null, fapiaoCancellationModalDisplayed ? /*#__PURE__*/React.createElement(ModalConfirm, {
    appElement: "#researcher-app",
    close: function close() {
      return setFapiaoCancellationModalDisplayed(false);
    },
    show: true,
    yesAction: handleCancelFapiao
  }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(T, {
    source: "fapiao-cancellation-request-type-".concat(fapiao.type)
  }))) : null, /*#__PURE__*/React.createElement("button", {
    "aria-label": t('Cancel fapiao'),
    className: "d-block btn-link w-100 px-2",
    onClick: function onClick() {
      return setFapiaoCancellationModalDisplayed(true);
    },
    type: "button"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Cancel fapiao"
  }))) : null;
};
export default CancelFapiaoLink;